import React from "react";
import {  motion } from "framer-motion";
// import Image from "next/image";
import style from "./Transition.module.css";

// import logo from "/public/Vector.svg";

export const Transition = ({ children, className }) => {
  const anmi = (variants, custom) => ({
    initial: "initial",
    animate: "enter",
    exit: "exit",
    variants,
    custom,
  });

  // Opacity animation
  const opacity = {
    initial: { opacity: 0 },
    enter: {
      opacity: 1,
      transition: { duration: 0.5, ease: [0.76, 0, 0.24, 1] },
    },
    exit: {
      opacity: 0,
      transition: { duration: 0.5, ease: [0.76, 0, 0.24, 1] },
    },
  };

  // Expanding blocks animation
  const expand = {
    initial: { height: "100%" },
    enter: (i) => ({
      height: "0%",
      transition: { duration: 0.3, ease: [0.76, 0, 0.5, 1], delay: 0.05 * i },
      transitionEnd: { height: 0 },
    }),
    exit: (i) => ({
      height: "100%",
      zIndex: -2,
      transition: { duration: 0.5, delay: 0.05 * i },
    }),
  };

  // Logo rotation animation
  const rotate = {
    initial: { opacity: 1, top: "0px" },
    enter: {
      opacity: 0,
      top: "80px",
      transition: { duration: 0.5, ease: [0.76, 0, 0.5, 1] },
    },
    exit: { opacity: 1 },
  };

  // Display animation
  const display = {
    initial: { display: "flex" },
    enter: {
      display: "none",
      transition: { duration: 0.5, ease: [0.76, 0, 0.5, 1] },
    },
    exit: { display: "none" },
  };

  return (
    <div className={style.transition}>
      
      <motion.div {...anmi(display)} className={style.transition_container}>
        <motion.div
          className={`flex justify-center align-center ${style.logo}`}
          {...anmi(rotate)}
        >
          {/* <Image src={logo} alt="Logo" width={300} height={300} /> */}
        </motion.div>
        {[...Array(6)].map((_, i) => (
          <motion.div
            {...anmi(expand, i)}
            key={i}
            className={style.transition_item}
          ></motion.div>
        ))}
      </motion.div>
        <motion.div {...anmi(opacity)} className={className}>
        {children}
      </motion.div>
    </div>
  );
};
